import styled from 'styled-components';

export const TitleWrapper = styled('span')`
  padding-right: 10px;
  height: 15px;
  font-size: 10px;
`;
